import { createContext, useContext } from "react"

const NodeContext = createContext({
  onLabelChange: () => {},
})

export function NodeProvider({ children, onLabelChange }) {
  return (
    <NodeContext.Provider value={{ onLabelChange }}>
      {children}
    </NodeContext.Provider>
  )
}

export function useNodeContext() {
  return useContext(NodeContext)
}

export default NodeContext
